import { PieChart, Pie, Cell, Tooltip, Legend, ResponsiveContainer } from 'recharts';
const LCPieChart = ({ data = [] }) => {
  if (data.length === 0) return null;
  const keys = Object.keys(data[0]);
  const nameKey = keys[0];
  const dataKey = keys[1];

  const COLORS = ['#0a2463','#b0c4de'];
  return (
    <ResponsiveContainer width="100%" height={400}>
      <PieChart>
        <Tooltip />
        <Legend />
        <Pie
          data={data}
          dataKey={dataKey}
          nameKey={nameKey}
          height="100%"
          label
        >
          {data.map((_, index) => (
            <Cell key={index} fill={COLORS[index]} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default LCPieChart;
